// extracted by mini-css-extract-plugin
export default {"integrationLinkContent":"e8c74a62b88b","linkButton":"dd50b5eb1ad4"};